// extracted by mini-css-extract-plugin
export default {"all_devices__table":"styles_all_devices__table__UkDUq"};